// extracted by mini-css-extract-plugin
module.exports = {"myfeed":"Myfeed_myfeed__3r8S4","text":"Myfeed_text__3UeSh","feed_link":"Myfeed_feed_link__14pcX","feed_item":"Myfeed_feed_item__GwUHR","stack_down":"Myfeed_stack_down__3C5x2"};